import React, { Component, Fragment } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import history from "~/history";
import * as featuresActions from "~/store/features/featuresActions";
import {
  requestHospitalList,
  resetFeatureListByHospital
} from "~/store/hospital/hospitalActions";
import * as rebooking from "~/store/rebooking/rebookingAction";
import { requestAllCity } from "~/store/resource/resourceAction";
import { resetData } from "~/store/totalData/actions";
import AppId from "~/utils/partner";

const Desktop = Loadable({
  loader: () => import("~/components/desktop/pages/ChooseHospital"),
  loading: LoadableLoading,
  delay: 10
});

class ChooseHospital extends Component {
  componentWillMount() {
    const listAppId = ["medpro", "momo"];
    if (!listAppId.includes(AppId)) {
      history.push("/");
    }
  }

  componentDidMount() {
    this.props.requestHospitalList();
    this.props.clearFollowupState();
    this.props.resetFeatureListByHospital();
    this.props.resetData();
    this.props.requestAllCity();
  }

  render() {
    return (
      <Fragment>
        <Desktop {...this.props} {...this.methods} />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    hospital: {
      selectedHospital,
      featureList: { data: featureList },
      hospitalList: { data: hospitalList }
    },
    features: { selectedFeature, featureListBooking },
    user: { IsAuthenticated },
    resource: { dataCity: allCities }
  } = state;
  return {
    device: type,
    selectedHospital,
    selectedFeature,
    IsAuthenticated,
    featureList,
    featureListBooking,
    hospitalList,
    allCities
  };
};

const mapDispatchToProps = dispatch => ({
  clearFollowupState: () => dispatch(rebooking.clearState()),
  resetFeatureListByHospital: () => {
    dispatch(resetFeatureListByHospital());
  },
  selectFeatureBookingById: id =>
    dispatch(featuresActions.selectFeatureBookingById(id)),

  requestHospitalList: () => {
    dispatch(requestHospitalList());
  },
  resetData: () => {
    dispatch(resetData());
  },
  requestAllCity: () => {
    dispatch(requestAllCity());
  }
});

const ChooseHospitalHelmet = withTitle({
  component: ChooseHospital,
  title: "Medpro | Chọn bệnh viện"
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChooseHospitalHelmet)
);
